/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CardTypeConsentDTO,
    CardTypeConsentDTOFromJSON,
    CardTypeConsentDTOFromJSONTyped,
    CardTypeConsentDTOToJSON,
} from './CardTypeConsentDTO';

/**
 * 
 * @export
 * @interface PersonDTO
 */
export interface PersonDTO {
    /**
     * 
     * @type {string}
     * @memberof PersonDTO
     */
    id?: string;
    /**
     * 
     * @type {Array<CardTypeConsentDTO>}
     * @memberof PersonDTO
     */
    cardTypeConsents?: Array<CardTypeConsentDTO>;
}

export function PersonDTOFromJSON(json: any): PersonDTO {
    return PersonDTOFromJSONTyped(json, false);
}

export function PersonDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): PersonDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'cardTypeConsents': !exists(json, 'cardTypeConsents') ? undefined : ((json['cardTypeConsents'] as Array<any>).map(CardTypeConsentDTOFromJSON)),
    };
}

export function PersonDTOToJSON(value?: PersonDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'cardTypeConsents': value.cardTypeConsents === undefined ? undefined : ((value.cardTypeConsents as Array<any>).map(CardTypeConsentDTOToJSON)),
    };
}

